import { __, _n } from '@wordpress/i18n';
import { ICS_Admin_Page_Settings } from '../interface.currency-switcher-admin-page-settings';
import { IREST_Order_Import_Result } from './interface.class.action-run-order-import';
import { Definitions } from '../class.definitions';

/**
 * Implements the scripts that allow the user to trigger the import of sales
 * data from the settings page.
 *
 * @since 5.0.4.230626
 */
export class Currency_Switcher_Action_Run_Order_Import {
	/**
	 * The settings passed to the class.
	 *
	 * @var ICS_Admin_Page_Settings
	 */
	protected settings: ICS_Admin_Page_Settings;

	/**
	 * Constructor.
	 *
	 * @param settings ICS_Admin_Page_Settings
	 */
	public constructor(settings: ICS_Admin_Page_Settings) {
		this.settings = settings;

		this.init_event_handlers();
	}

	/**
	 * Given an ID, returns the localised messages matching the ID. The list of strings
	 * is passed by the backend to the frontend via the localize_script() function.
	 *
	 * @param text_id The ID of the text to return
	 * @returns A string of text matching the ID.
	 */
	protected get_text(text_id: number): string {
		return this.settings.l10n.import_order_data[text_id] ??	[__('Text not found for specified ID:', this.settings.text_domain), text_id.toString()].join(' ');
	}

	/**
	 * Initialises the event handlers required by this class.
	 *
	 * @returns void
	 */
	protected init_event_handlers(): void {
		jQuery('#wc_aelia_currency_switcher_form #import_sales_data').on('click', (event) => {
			(async () => {
				event.stopPropagation();

				const $action_element = jQuery(event.target);
				const $operation_result_element = jQuery('.order_import .action_result');

				$operation_result_element.html('').hide();

				$action_element.prop('disabled', true);
				const operation_result = await this.start_order_import();

				$operation_result_element.html(operation_result['message']).removeClass('flash').show().addClass('flash');

				// Disable the import button for one minute upon success, or five seconds in case of error. This will
				// allow the users the time to review the response message and decide what to do
				const timeout: number = (operation_result.code !== 200) ? 5000 : 60000;

				// Re-enable the "import" button after a specific period of time. Restarting the import process
				// won't cause issues, but disabling the button for a while can help preventing accidental double clicks
				setTimeout(() => {
					$action_element.prop('disabled', false);
				}, timeout);

				return false;
			})();
		});
	}

	/**
	 * Returns the result of the validation of the API credentials entered on the Freemius Integrration setting page.
	 *
	 * @returns Promise<IREST_Order_Import_Result>
	 */
	protected async start_order_import(): Promise<IREST_Order_Import_Result> {
		const api_url: string = `${this.settings.rest.root_url}/${this.settings.rest.namespace}/${this.settings.rest.api_version}/import-order-data`;

		// Send the call to the local API, which will then try to connect to Freemius
		const response = await fetch(`${api_url}`, {
			method: 'POST',
			headers: {
				'content-type': 'application/json; charset=UTF-8',
				'X-WP-Nonce': this.settings.rest.nonce,
			},
		})

		let result: IREST_Order_Import_Result;

		if(!response.ok) {
			console.error([__('Request failed. HTTP status:', this.settings.text_domain), response.status].join(' '));

			result = {
				code: response.status,
				message: this.get_text(Definitions.ERR_REST_HTTP_ERROR),
			}
			return result;
		}

		// Process the response returned by the REST API
		const response_text = await response.text();
		try {
			// Try to parse the response as JSON
			const response_data = JSON.parse(response_text);
			console.debug(__('Valid response received.', this.settings.text_domain), response_data);

			// Return the message from the response
			result = {
				'code': response.status,
				'message': response_data['message'],
			}
		}
		catch(error) {
			result = {
				'code': response.status,
				'message': this.get_text(Definitions.ERR_REST_INVALID_API_RESPONSE),
			}
			// If the parsing fails, return the body as text
			console.error([__('Unexpected response retured by the API. Response:', this.settings.text_domain), response_text].join(' '));
		}

		return result;
	}
}
